import React from 'react';
import { ArrowRight } from 'lucide-react';
import type { ColumnMapping } from '../../../types/import';

interface ColumnMapperProps {
  availableColumns: string[];
  mapping: ColumnMapping;
  onUpdateMapping: (field: string, column: string) => void;
}

const REQUIRED_FIELDS = ['first_name', 'last_name'];
const OPTIONAL_FIELDS = [
  'company',
  'job_title',
  'phone_number',
  'work_phone',
  'personal_email',
  'work_email',
  'linkedin_url',
  'birthday',
  'significant_other',
  'children_details'
];

export default function ColumnMapper({ availableColumns, mapping, onUpdateMapping }: ColumnMapperProps) {
  const getFieldLabel = (field: string) => {
    return field
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Trim whitespace from column names
  const trimmedColumns = availableColumns.map(col => col.trim());

  return (
    <div className="space-y-4">
      <h3 className="font-medium text-lg">Map Columns</h3>
      
      <div className="space-y-4">
        <div className="space-y-2">
          <h4 className="text-sm font-medium text-primary-400">Required Fields</h4>
          {REQUIRED_FIELDS.map(field => (
            <div key={field} className="flex items-center space-x-4">
              <div className="w-1/3">
                <span className="text-sm font-medium">{getFieldLabel(field)}</span>
                <span className="text-red-500 ml-1">*</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
              <div className="w-1/2">
                <select
                  value={mapping[field] || ''}
                  onChange={(e) => onUpdateMapping(field, e.target.value)}
                  className="input w-full text-sm"
                >
                  <option value="">Select column...</option>
                  {trimmedColumns.map(column => (
                    <option key={column} value={column}>{column}</option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-2">
          <h4 className="text-sm font-medium text-gray-400">Optional Fields</h4>
          {OPTIONAL_FIELDS.map(field => (
            <div key={field} className="flex items-center space-x-4">
              <div className="w-1/3">
                <span className="text-sm">{getFieldLabel(field)}</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
              <div className="w-1/2">
                <select
                  value={mapping[field] || ''}
                  onChange={(e) => onUpdateMapping(field, e.target.value)}
                  className="input w-full text-sm"
                >
                  <option value="">Select column...</option>
                  {trimmedColumns.map(column => (
                    <option key={column} value={column}>{column}</option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}